/** @jsxImportSource @emotion/react */
import { Box, Tab, Tabs, Typography, useTheme } from '@mui/material'
import { useAtomValue } from 'jotai'
import { Outlet, useNavigate, useMatch } from 'react-router-dom'
import { isStaffAtom } from '@app/hooks/useUserProfile'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { AdminPageContainer, AdminPageContentContainer } from '../styles/Admin.styles'
import { FEATURE_FLAGS } from '@app/app-constants'

export const AdminLayout = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const isStaff = useAtomValue(isStaffAtom)
  const { useFeatureFlag } = useFeatureFlags()
  const isLayerPermissionsEnabled = useFeatureFlag(FEATURE_FLAGS.LAYER_PERMISSIONS)

  // Determine current tab from URL
  const isManageUsersRoute = useMatch('/app/admin/manage-users')
  const isFeatureFlagsRoute = useMatch('/app/admin/feature-flags')
  const isLayerPermissionsRoute = useMatch('/app/admin/layer-permissions')

  let currentTab = 0

  if (isManageUsersRoute) {
    currentTab = 0
  } else if (isLayerPermissionsRoute) {
    currentTab = 1
  } else if (isFeatureFlagsRoute) {
    currentTab = 2
  }

  return (
    <Box css={AdminPageContainer({ theme })}>
      <Box css={AdminPageContentContainer({ theme })}>
        <Box>
          <Typography variant="h2" sx={{ color: theme.palette.primary.dark, mb: 2 }}>
            Admin Settings
          </Typography>
        </Box>

        <Tabs
          css={{ mb: 3, borderBottom: `1px solid #c3c3c3`, width: '100%' }}
          value={currentTab}
          onChange={(_, newValue) => {
            if (newValue === 0) {
              navigate('/app/admin/manage-users')
            } else if (newValue === 1 && isLayerPermissionsEnabled) {
              navigate('/app/admin/layer-permissions')
            } else if (newValue === 2 || (newValue === 1 && !isLayerPermissionsEnabled)) {
              navigate('/app/admin/feature-flags')
            }
          }}
        >
          <Tab label="Manage Users" />
          {isLayerPermissionsEnabled && <Tab label="Layer Permissions" />}
          {isStaff && <Tab label="Feature Flags" />}
        </Tabs>

        <Outlet />
      </Box>
    </Box>
  )
}
